import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  reportMenu: {
    display: 'flex',
    gap: 20,
    marginTop: 34
  },
  deleteButton: {
    marginLeft: 'auto'
  }
})

export default useStyles
